import { useState } from 'react';

interface UseModalReturnType {
  visible: boolean;
  open: () => void;
  close: () => void;
}

export const useModal = (initialValue = false): UseModalReturnType => {
  const [visible, setVisible] = useState(initialValue);
  const open = () => setVisible(true);
  const close = () => setVisible(false);

  return {
    visible,
    open,
    close,
  };
};
